import { useRouteSync } from "@hooks/useRouteSync";
import { useTranslation } from "react-i18next";
import { Outlet, useLocation, useNavigate } from "react-router-dom";

export default function AppLayout() {
  const navigate = useNavigate();
  const location = useLocation();
  const { t: translate } = useTranslation("translation");
  
  useRouteSync();
  
  // Don't show back button on the dashboard (root path)
  const showBackButton = location.pathname !== "/";

  const handleBackClick = () => {
    navigate(-1);
  };

  return (
    <>
      <Outlet />
      {showBackButton && (
        <div className="p-4">
          <button
            className="flex items-center gap-2 text-secondTextColor transition-colors hover:text-mainTextColor"
            onClick={handleBackClick}
          >
            <svg 
              className="size-5 rtl:rotate-180" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
            >
              <path 
                d="M15 19l-7-7 7-7" 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2}
              />
            </svg>
            {translate("back")}
          </button>
        </div>
      )}
    </>
  );
}

export const AuthWrapper = AppLayout;
